import type { NavigationGuardNext, Router } from "vue-router";

export default async function auth({ next, router }: { next: NavigationGuardNext, router: Router }) {
    if (!localStorage.getItem("asl_access_token")) {
        return router.push('/login');
    }

    return next();
}